module.exports = __webpack_public_path__ + "static/rcc-581-study-design-mobile-46d6081c29db288430549bb551bd67bd.png";